// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect, useRef } from "react";
import { Auth, Hub } from "aws-amplify";

// Contextの作成
const AuthContext = createContext();

// プロバイダの作成
export const AuthProvider = ({ children }) => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const isFirstTimeRef = useRef(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        setIsUserLoggedIn(true);
        setUserInfo(user);
      } catch (error) {
        setIsUserLoggedIn(false);
        setUserInfo(null);
      } finally {
        setIsLoading(false);
      }
    };

    const listener = (data) => {
      switch (data.payload.event) {
        case "signIn":
          setIsUserLoggedIn(true);
          setUserInfo(data.payload.data);
          break;
        case "signOut":
          setIsUserLoggedIn(false);
          setUserInfo(null);
          break;
        case "updateUserAttributes":
          checkAuthStatus();
          break;
        default:
          break;
      }
    };
    const hubListenerCancelToken = Hub.listen("auth", listener);

    // コンポーネントマウント時に一度認証状態をチェック
    checkAuthStatus();

    // クリーンアップ関数
    return () => hubListenerCancelToken();
  }, []);

  // 未ログインのダイアログ表示
  useEffect(() => {
    if (!isLoading && isFirstTimeRef.current) {
      if (!isUserLoggedIn) {
        // 未ログイン
        window.dispatchEvent(new CustomEvent("showAboutViewerModal"));
      }
      isFirstTimeRef.current = false;
    }
  }, [isLoading, isUserLoggedIn]);

  const value = { isUserLoggedIn, isLoading, userInfo };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Contextを簡単に利用するためのカスタムフック
export const useAuthStatus = () => {
  return useContext(AuthContext);
};
